import PaymentOption from './paymentOption';

export default PaymentOption;
